import { render, staticRenderFns } from "./AmazeComment.vue?vue&type=template&id=d0369b58&scoped=true"
import script from "./AmazeComment.vue?vue&type=script&lang=js"
export * from "./AmazeComment.vue?vue&type=script&lang=js"
import style0 from "./AmazeComment.vue?vue&type=style&index=0&id=d0369b58&prod&lang=scss&scoped=true"
import style1 from "./AmazeComment.vue?vue&type=style&index=1&id=d0369b58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0369b58",
  null
  
)

export default component.exports